<template>
    <div>
        <div class="flex justify-between text-sm">
            <p class="font-medium text-iron-700">
                {{ $t("event_types.booking_page.link") }}
            </p>
        </div>

        <InputWithPrefix
            :model-value="teamUrlName"
            :variant="variant"
            @update:model-value="updateValue"
        >
            <template #prefix>
                <span
                    class="inline-flex h-10 shrink-0 items-center rounded-l-md border border-r-0 border-iron-300 bg-iron-50 px-3 text-iron-600 sm:text-sm"
                    >{{ `zapti.me/` }}</span
                >
            </template>
        </InputWithPrefix>

        <div v-if="error" class="mt-2 text-sm text-error-500">
            {{ error.reason }}
        </div>

        <div v-if="dirty" class="flex justify-end">
            <Button :disabled="!isValid" @click="save">{{ $t("save") }}</Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import InputWithPrefix from "@/components/ui/input-with-prefix/InputWithPrefix.vue";
import { computed, ref } from "vue";
import { Button } from "@/components/ui/button";
import axios from "axios";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";

import { useI18n } from "vue-i18n";

import { usePage } from "@inertiajs/vue3";

const dirty = ref(false);

const error = ref<{ reason: string }>({
    reason: "",
});

const page = usePage();

console.log(page.props);

const { t } = useI18n();

const teamUrlName = ref(page.props.personalTeam.slug);

const variant = computed(() => {
    return error.value.reason ? "error" : "default";
});

const isValid = computed(() => {
    return !!error.value.reason === false;
});

const alphanumericDashPattern = /^[a-zA-Z0-9-]+$/;

function validateSlug(newSlug: string) {
    newSlug = newSlug.replaceAll(" ", "-");

    if (newSlug.length > 64) {
        error.value.reason = t("event_types.booking_page.link_length");
    } else if (!alphanumericDashPattern.test(newSlug)) {
        error.value.reason = t("event_types.booking_page.link_special_chars");
    } else {
        error.value = { reason: "" };
    }

    return newSlug;
}

const updateValue = (value: string) => {
    teamUrlName.value = validateSlug(value);
    dirty.value = true;
};

async function save() {
    if (error.value.reason) {
        return;
    }

    try {
        const res = await axios.post(
            route("app.teams.slugs.check", {
                team: page.props.personalTeam.id,
            }),
            {
                slug: teamUrlName.value,
            },
        );

        if (res.data.data.slug === teamUrlName.value) {
            router.put(
                route("app.teams.slugs.update", {
                    team: page.props.personalTeam.id,
                }),
                {
                    slug: teamUrlName.value,
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                },
            );
        } else {
            error.value.reason = t(
                "event_types.booking_page.link_alerady_exists",
            );
        }
        dirty.value = false;
    } catch (e) {
        // @ts-expect-error
        error.value.reason = e.response.data.message;
    }
}
</script>
